import {CabinetTransform} from 'components/customer/RoomPlanner/store/roomPlannerSlice';
import {CabinetMesh} from 'components/customer/RoomPlanner/types';

export const resetOriginalCabinetPosition = (props: {
    cabinetGroupListRef: React.MutableRefObject<CabinetMesh[]>;
    oldCabinets: CabinetTransform[];
    autoSave: (cabinetGroup: CabinetMesh, checkPreview?: boolean) => void;
}) => {
    const {cabinetGroupListRef, oldCabinets, autoSave} = props;

    cabinetGroupListRef.current.forEach((cabinetGroup) => {
        const id = String(cabinetGroup.userData?.values?.duplicate_id);
        const oldCabinet = oldCabinets.find((cab) => {
            return String(cab.id) === id;
        });

        if (id === undefined) return;

        cabinetGroup.position.set(
            oldCabinet.position.x,
            oldCabinet.position.y,
            oldCabinet.position.z
        );
        cabinetGroup.rotation.set(
            oldCabinet.rotation.x,
            oldCabinet.rotation.y,
            oldCabinet.rotation.z
        );
    });

    cabinetGroupListRef.current.forEach((cabinetGroup) => {
        autoSave(cabinetGroup);
    });
};
